import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    isSSR: false,
    leadDetails: {},
    cmsData: {},
    seoData: {}
};

export const setScrapCarContent = (state = INITIAL_STATE, { data }) => {
    return { ...state, ...data };
};
export const setSSRStatus = (state = INITIAL_STATE, { isSSR }) => {
    return { ...state, isSSR };
};

export const setLeadDetails = (state = INITIAL_STATE, { leadDetails }) => {
    return { ...state, leadDetails };
};

export const setShowAnimation = (state = INITIAL_STATE, {showAnimation}) => {
    return { ...state, showAnimation};
};
export const HANDLERS = {
    [Types.SET_SSR_STATUS]: setSSRStatus,
    [Types.SET_LEAD_DETAILS]: setLeadDetails,
    [Types.SET_SCRAP_DATA_SUCCESS]: setScrapCarContent,
    [Types.SET_SHOW_ANIMATION]: setShowAnimation

};

export default createReducer(INITIAL_STATE, HANDLERS);
